<p-columnFilter type="text"
                [placeholder]="placeholder"
                [field]="field"
                [showClearButton]="false"
                [matchMode]="defaultMatch"
                [matchModeOptions]="customMatchModeOptions"
>
    <ng-template pTemplate="filter" let-value let-filter="filterCallback">
        <app-input [model]="value" (modelChange)="filter($event)"
                   [inputWidth]="inputWidth"
                   [showLength]="false" [debounceDelay]="500"
        ></app-input>
    </ng-template>
</p-columnFilter>
